import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/ui/styles/globals.css";

import { Logger } from "@liberty-fund/logger";

import { analytics } from "./analytics";
import App from "./App";
import { initiatizeMetrics } from "./utils/awsrum";

// Fire and forget: RUM configuration is fetched, and telemetry must never be
// on the critical path to rendering.
void initiatizeMetrics();
// Same for Mixpanel, which loads its SDK lazily and queues events until then.
analytics.init();
Logger.debug("Host App");

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
